export default function addVideos() {
  let videoTarget = document.querySelectorAll('.banner-video .video.-horizontal');

  videoTarget.forEach((target, index) => {
    setTimeout(() => {
      target.innerHTML = delayVideos[index];
      target.classList.remove('-loading');
      lazyLoadInstance.update();
    }, 3000);
  });
}
